import {MetricUser} from '../models/metric-user.model';

export interface MetricUsersResponse {
  users: [MetricUser]
}
